import { useState, useEffect, useContext } from 'react';
import { PersonContext } from '../../context/PersonContext'; // PersonContext를 가져옵니다.
import { DialogContext } from '../../context/DialogContext'; // DialogContext를 가져옵니다.
import './login.css'; // login.css 파일을 임포트합니다.

const PersonLogin = () => {
  const [name, setName] = useState('');
  const [handphone, setHandphone] = useState('');
  const [secretcode, setSecretcode] = useState('');
  const [authcode, setAuthcode] = useState('');
  const [error, setError] = useState('');
  const [isAuthcodeChecked, setIsAuthcodeChecked] = useState(false); // 인증번호 확인 여부 상태
  const { setPerson } = useContext(PersonContext); // PersonContext에서 setPerson을 가져옵니다.
  const { closeDialog } = useContext(DialogContext); // closeDialog를 가져옵니다.
  const host = process.env.REACT_APP_RESTAPI_URL;

  useEffect(() => {
    //if (error) alert(error);
  }, [error]);

  const handleSendAuthCode = async () => {
    const url = `${host}/oauth/sendUms`;
    console.log(`인증번호 발송 시도 : ${url}`);
    setAuthcode(''); // 인증번호를 초기화합니다.
    setSecretcode(''); // 입력된 인증번호를 초기화합니다.
    setIsAuthcodeChecked(false); // 인증번호 확인 상태를 초기화합니다.
    setError(''); // 오류 메시지를 초기화합니다.

    try {
      const response = await fetch(url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ name, handphone }),
      });
      if (!response.ok) throw new Error('입력하신 성명과 핸드폰 번호로 등록된 감독관을 찾을 수 없습니다. 입력된 정보에 이상이 없으면, 협회나 해당 지역본부에 감독관 등록 여부를 확인해 주시기 바랍니다.');
      const data = await response.json();
      console.log(data);
      console.log(`인증번호 발송 성공 : ${data}`);
      setAuthcode(data.authcode); // 인증번호가 발송되었음을 표시합니다.
      alert('인증번호가 발송되었습니다. 확인 후 입력해주세요.');
    } catch (error) {
      console.error('인증번호 발송 오류:', error);
      setError(error.message);
    }
  };

  const handleLogin = async () => {
    const url = `${host}/oauth/umslogin`;
    console.log(`로그인 시도 : ${url}`);

    if (!name) {
      setError('성명을 입력해주세요.');
      return;
    }

    if (!handphone) {
      setError('핸드폰번호를 입력해주세요.');
      return;
    }

    const h = handphone.replace(/[^0-9]/g, ''); // 핸드폰번호에서 숫자만 남깁니다.
    if (h.length < 10 || h.length > 11) {
      setError('핸드폰번호는 10자리 또는 11자리 숫자로 입력해주세요.');
      return;
    }

    if (!authcode) {
      setError('인증번호를 먼저 발송해주세요.');
      return;
    }

    if (!secretcode || secretcode !== authcode) {
      setError('인증번호가 일치하지 않습니다. 다시 확인해주세요.');
      return;
    }

    try {
      const response = await fetch(url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ name, handphone, secretcode, authcode }),
      });

      console.log(`로그인 응답 : ${response.status} ${response.statusText}`);

      if (!response.ok) {
        throw new Error('로그인 실패');
      }

      const data = await response.json();
      console.log(`로그인 성공 : ${data}`);
      // 로그인 성공 시 받은 토큰을 sessionStorage에 저장합니다.
      sessionStorage.setItem('token', data);
      setError('');

      // sessionStorage에서 토큰을 가져옵니다.
      const token = sessionStorage.getItem('token');
      console.log(`토큰 : ${token}`); // 토큰을 콘솔에 표시합니다.
      if (!token) {
        throw new Error('토큰이 없습니다.');
      }

      // 토큰을 사용하여 사용자 정보를 가져옵니다.
      const personResponse = await fetch(`${host}/oauth/person`, {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      });

      if (!personResponse.ok) {
        throw new Error('사용자 정보 가져오기 실패');
      }

      console.log(personResponse);

      const personInfo = await personResponse.json();
      console.log('사용자 정보');
      console.log(personInfo);
      setPerson(personInfo); // 사용자 정보를 설정합니다.
      closeDialog(); // dialog 창을 닫습니다.
      //window.location.reload(); // 로그인 성공 후 페이지를 새로고침합니다.
      //window.location.href = '/'; // 로그인 성공 후 홈으로 이동합니다.
    } catch (error) {
      console.error('로그인 오류:', error);
      setError(error.message);
    }
  };

  const handleVerifyAuthCode = () => {
    console.log(`인증번호 확인 시도 : ${authcode} / ${secretcode}`);
    if (!secretcode) {
      setError('인증번호를 입력해주세요.');
      return;
    }

    if (secretcode !== authcode) {
      setError('인증번호가 일치하지 않습니다. 다시 확인해주세요.');
      return;
    }

    setError('');
    setIsAuthcodeChecked(true); // 인증번호 확인 상태를 true로 설정합니다.
    alert('인증번호가 확인되었습니다. 로그인 버튼을 클릭하여 로그인하세요.');
  };

  return (
    <div id="person_login">
      <div className="head">
        <h1>로그인</h1>
      </div>
      <div className="body">
        <ul className="form">
          <li>
            <label>성명</label>
            <span>
              <input
                type="text"
                placeholder="성명을 입력하세요."
                value={name}
                onChange={(e) => setName(e.target.value)}
              />
            </span>
          </li>
          <li>
            <label>핸드폰번호</label>
            <span>
              <input
                type="text"
                placeholder="핸드폰번호를 숫자로만 입력하세요."
                value={handphone}
                onChange={(e) => setHandphone(e.target.value)}
                className='handphone'
              />
              <button onClick={handleSendAuthCode}>{ authcode ? '재전송' : '발송하기' }</button>
            </span>
          </li>
          {authcode && (
          <li>
            <label>인증번호</label>
            <span>
              <input
                type="text"
                placeholder="인증번호를 입력하세요."
                value={secretcode}
                onChange={(e) => setSecretcode(e.target.value)}
                className='secretcode'
              />
              <button onClick={handleVerifyAuthCode}>확인하기</button>
            </span>
          </li>
          )}
        </ul>
        {error && <div className="error">{error}</div>}
      </div>
      <div className="foot">
          <button className="login" onClick={handleLogin} disabled={!isAuthcodeChecked}>로그인</button>
          <button className="cancel" onClick={closeDialog}>닫기</button>
        </div>
    </div>
  );
};

export default PersonLogin;
